// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__DSC7S","body":"styles_body__kJ3p9"};